button {
  display: flex;
  max-width: 100%;
  height: 36px;
  align-items: center;
  padding: 0 var(--space-unit);
  border: var(--border-size-medium) solid var(--color-primary01);
  background-color: var(--color-surface01);
  border-radius: var(--border-radius);
  color: var(--color-primary01);
  cursor: pointer;
  fill: var(--color-primary01);
  font-family: var(--font-family-sans);
  font-size: 14px;
  font-weight: var(--font-sb);
  outline: none;
}

button::-moz-focus-inner {
  border: 0;
}

button:hover {
  border-color: var(--color-hover-primary);
  color: var(--color-hover-primary);
  fill: var(--color-hover-primary-icon);
}

button:focus {
  border-color: var(--color-primary01);
  box-shadow: var(--shadow-focus-primary);
  color: var(--color-primary01);
  fill: var(--color-primary01);
}

button:active {
  border-color: var(--color-pressed-primary);
  box-shadow: var(--shadow-2);
  color: var(--color-pressed-primary);
  fill: var(--color-active-primary-icon);
}

button.selected {
  border-color: var(--color-hover-primary);
  background-color: var(--color-hover-primary);
  color: var(--color-text-inverse);
  fill: var(--color-inverse-icon);
}

button > span.ellipsis {
  overflow: hidden;
  padding: 0;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

button > span.counter {
  margin-right: calc(var(--space-unit) * 2);
  margin-left: calc(var(--space-unit) / 2);
}

button > span.sort {
  margin-right: calc(var(--space-unit) / 2);
  white-space: nowrap;
}

button > span {
  margin-right: calc(var(--space-unit) / 2);
}

/* Tablet breakpoint */
@media (min-width: 768px) {
  button {
    max-width: 325px;
  }
}

/* Desktop breakpoint */
@media (min-width: 1152px) {
  button {
    max-width: 490px;
  }
}
